// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareCardCommandButton__emoji-a5a00c {
  margin-inline-start: 5px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/ButtonsBubble/CommandButtons/ShareCardCommandButton/ShareCardCommandButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,sBAAA;AACF","sourcesContent":[".emoji {\n  margin-inline-start: 5px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emoji": `ShareCardCommandButton__emoji-a5a00c`
};
module.exports = ___CSS_LOADER_EXPORT___;
